<template>
    <div>
        <div class="flex flex-row align-center" style="background-color: #FBE5E1">
            <div class="p-2">
                <code class="d-block" v-html="code"></code>
            </div>
            <v-btn icon color="primary" @click="copy" v-if="copyable">
                <v-icon small>fal fa-copy</v-icon>
            </v-btn>
        </div>
        <v-snackbar v-model="snackbarOpen" :timeout="2500" :multi-line="false">
            Copied to clipboard!
        </v-snackbar>
    </div>
</template>
<script>

export default {
    props: {
        code: {
            type: String, 
            required: true,
        },
        copyable: {
            type: Boolean,
            required: false,
            default: () => {
                return true;
            }
        },
    },

    data: () => ({
        snackbarOpen: false,
    }),

    methods: {
        copy() {
            window.navigator.clipboard.writeText(this.code).then(() => {
                this.snackbarOpen = true;
            });
        },
    }
}
</script>
